import { autoLc } from '@/locales/ko/views/request_map';
const lc = autoLc('list.');
export const tableHeader = [
    // 아이디
    {
        title: lc('table.id'),
        align: 'center',
        width: 100,
    },
    // 요청 구분
    {
        title: lc('table.operation_type'),
        align: 'center',
        width: 100,
    },
    // 주소
    {
        title: lc('table.address'),
        align: 'center',
    },
    // 결과
    {
        title: lc('table.result'),
        align: 'center',
        width: 90,
    },
    // 요청자
    {
        title: lc('table.created_by'),
        align: 'center',
        width: 90,
    },
    // 등록일
    {
        title: lc('table.created_time'),
        align: 'center',
        width: 140,
    },
];
export const enumOperationType = {
    CREATE: lc('operation_type.create'),
    UPDATE: lc('operation_type.update'),
};
export const enumOperationDetailType = {
    PLACE_NAME: 'PLACE_NAME',
    ADMINISTRATIVE_AREA: 'ADMINISTRATIVE_AREA',
    ZERO_LOT_NUMBER: 'ZERO_LOT_NUMBER',
};
/**
 * 다음 주소 검색시에 서버로 보내야 하는 지역 코드를 알 수 없음.
 * 따라서 프론트에서 다음주소가 region_1depth_name 의 값을
 * 백엔드가 받을 값으로 치환해서 줘야 함.
 * 값만 문제 없다면 키는 지속적으로 추가 해도 됨
 * https://dev-zoo-client-api.barogo.io/docs/api-guide.html#_4_28_%EC%84%B8%EB%B6%80_%EC%A7%80%EB%AA%85_%EC%A7%80%EC%97%AD_%EC%BD%94%EB%93%9C_%EC%A1%B0%ED%9A%8C
 */
export const enumAreasDaumToBackend = {
    서울: 'SEOUL',
    경기: 'GYEONGGI',
    인천: 'INCHEON',
    대전: 'DAEJEON',
    충남: 'CHUNGNAM',
    충북: 'CHUNGBUK',
    강원특별자치도: 'GANGWON',
    // '강원도': 'GANGWON', 나중에 강원특별자치도가 강원도로 바뀐다면 이런식으로 추가하면 된다.
    대구: 'DAEGU',
    경북: 'GYEONGBUK',
    부산: 'BUSAN',
    울산: 'ULSAN',
    경남: 'GYEONGNAM',
    전북: 'JEONBUK',
    전남: 'JEONNAM',
    제주특별자치도: 'JEJU',
    세종특별자치시: 'SEJONG',
};
